import { http } from '../util/http';

export default class VehicleUploadsService {
	static getUploads() {
		return http.get(`/analytics/vehicle-uploads`);
	}
	static getUploadsByDate(body) {
		return http.post(`/analytics/vehicle-uploads`, body);
	}
}
